import React from 'react';

const ToggleSwitch = ({ isOn, handleToggle, label }) => {
  return (
    <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
      <label style={{ fontWeight: 'bold', marginRight: '10px' }}>{label}</label>
      <div 
        onClick={handleToggle}
        style={{
          position: 'relative',
          width: '50px',
          height: '26px',
          backgroundColor: isOn ? '#1891ff' : '#ccc',
          borderRadius: '13px',
          cursor: 'pointer',
          transition: 'background-color 0.2s',
        }}
      >
        <div
          style={{
            position: 'absolute',
            left: isOn ? '26px' : '2px',
            top: '2px',
            width: '22px',
            height: '22px',
            backgroundColor: 'white',
            borderRadius: '50%',
            transition: 'left 0.2s',
          }}
        />
      </div>
      <span style={{ marginLeft: '5px', fontSize: '14px' }}>
        {isOn ? 'On' : 'Off'}
      </span>
    </div>
  );
};

export default ToggleSwitch; 